import React, { memo } from 'react';
import styled from 'styled-components';
import { TemperatureReading } from './temperatureReading';
import { ForecastIcon } from './forecastIcon';

export const CurrentCondition = memo(() => {
    
    return (
        <CurrentConditionContainer>
            <CurrConditionIcon>
                <ForecastIcon />
            </CurrConditionIcon>
            <TemperatureReading />
        </CurrentConditionContainer>
    );
});

CurrentCondition.displayName = 'CurrentCondition';

const CurrentConditionContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 38%;
`;

const CurrConditionIcon = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 40%;
    height: 100%;
    img:first-child {
        width: 50%;
        height: auto;
    }
`;